<script>
const {
    rem: { parseStyle }
} = window.FEGOUtils;


export default {
    name: "page-pc",
    props: {
        tpl: {},
    },
    computed: {
        rootClass() {
            let r = [];
            let { type, autoHeight = true } = this.tpl.props || {};
            if (type === "card") {
                r.push("page-pc-card");
            }

            if (autoHeight) {
                r.push("auto-height");
            }
            return r;
        },
    },
    methods: {
        setStyle(tpl) {
            let { style } = tpl;

            return style && parseStyle(style);
        }
    },
};
</script>
<style lang="less" scoped>
.page-pc {
    position: static;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100% !important;
    background-size: 100% !important;
    background-repeat: no-repeat !important;
}

.page-pc-child {
    position: static;
}

.page-pc.auto-height {
    height: auto !important;
    min-height: 13.34rem; // 最小微一屏高度
}

.page-pc.page-pc-card {
    height: 100% !important;
    // 卡片式适配方法 @todo高度
}
</style>



// WEBPACK FOOTER //
// src/render/core.vue